import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	prioritySchemeDetailsTabPanelDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priority-scheme-details-tab-panel-description',
		defaultMessage:
			'Enter details of the new priority scheme and select <b>Projects</b> to associate it with projects. You can also change the default priority for this scheme here.',
		description: 'Modal description for the priority scheme details tab',
	},
});

export default messages;
